import { render, staticRenderFns } from "./TypeWordconnect.vue?vue&type=template&id=364ebbfa&"
import script from "./TypeWordconnect.vue?vue&type=script&lang=js&"
export * from "./TypeWordconnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports